export { default } from './MessageContent';
